import { css } from '@styles/theme'

export const stylesSimulateRanking = {
	titleBox: css({ display: 'flex', marginBottom: '46px' }),
}
